export default {
  namespaced: true,
  patrol_logs: {
    title: "Patrullaje",
    add_unit_log: "Add Log Record",
    patrol_log: {
      title: "Patrol Log",
      unit_log: "Unit Log",
      select_unit_log: "Select unit log",
      unit: "Facility",
      select_unit: "Select unit",
      shipping_time: "Shipping Time",
      arrival_time: "Arrival Time",
      departure_time: "Departure Time",
      revision_code: "Revision Code",
      select_revision_code: "Select revision code",
      comments: "Comments",
      assignment: "Assignment",
      surveillance: "Under surveillance",
      command_officer: "Command officer",
      select_command_officer: "Select Command officer",
      patrol_officer: "Patrol officer",
      select_patrol_officer: "Select Patrol officer",
      created_success: "Patrol log created successfully",
      updated_success: "Patrol log updated successfully",
      deleted_success: "Patrol log deleted successfully",
      review_time: "Review time",
      travel_time: "Travel time",
    },
    unit_log: {
      title: "Unit Log",
      unit: "Unit number",
      select_unit: "Select unit",
      commander: "Commander",
      select_commander: "Select commander",
      patrol_office: "Patrol Officer",
      telephone_number: "Telephone Number",
      router_number: "Route Number",
      active: "Active",
      select_status: "Select status",
      created_success: "Unit log created successfully",
      updated_success: "Unit log updated successfully",
      deleted_success: "Unit log deleted successfully",
    },
    unit_commander: {
      title: "Unit Commanders",
      name: "Name",
      telephone_number: "Telephone Number",
      placeholder_name: "Enter name",
      placeholder_telephone: "Enter telephone number",
      no_filters: "No filters available",
      created_success: "Unit commander created successfully",
      updated_success: "Unit commander updated successfully",
      deleted_success: "Unit commander deleted successfully",
    },
    revision_code: {
      title: "Revision Code",
      name: "Name",
      code: "Code",
      placeholder_name: "Enter name",
      placeholder_code: "Enter code",
      no_filters: "No filters available",
      created_success: "Revision code created successfully",
      updated_success: "Revision code updated successfully",
      deleted_success: "Revision code deleted successfully",
    },
  }
};
